import { createResidentSequence } from "../services/residentService";

export function useResidents() {
  async function createResident(data) {
    return await createResidentSequence(data);
  }

  return { createResident };
}
